/**
 * The model representing the document created on the fly by a template
 * @class
 */
UserDocs.Model.EVMDocument = Backbone.Model.extend(
/** @lends UserDocs.Model.EVMDocument# */
{
	/** set the field from the server to use as the unique id - can be accessed using this.id */
	idAttribute: "DOCUMENTID",
	
	guid: 0,
	
	EVMData: [],

	/** 
	 * Fetch the document
	 */
	loadTrialDocument: function(templateId) {
		let _this = this;
        return UserDocs.remote(
			"tryDocumentAJAX",
			{
				RAPIDOCSID: templateId
			}
		).then(async userdocument => {
            let document = userdocument.DOCUMENT;
            if (userdocument.DOCUMENTBRANDNEW == true && userdocument.TEMPLATEEXISTS == false) {
                _this.parse(document);
                _this.set(document);

                //fetchEVMs for this doc
                let EVMData = await _this.getEVMs();
                if (ele.config.permissions.evmdocuments) {
                    let docList = await _this.getDocumentList();
                }
            } else {
                //an instance already exists. Do nothing
                _this.guid = userdocument.GUID;
            }
            return userdocument;
		}).catch(e => {
		    //we want to UI to handle error in EVMs by just opening up the document
            throw new Error("Error")
        });
	},
	
	/** 
	 * Fetch the document - we-re assuming that it is a user document
	 */
	addItem: function(productpriceid) {
		let _this = this;
        return UserDocs.remote(
			"addItemAjax",
			{
				PRODUCTPRICEID: productpriceid
			}
        ).then(async userdocument => {
            if (userdocument.guid) {
                _this.parse(userdocument);
                _this.set(userdocument);

                let EVMData = await _this.getEVMs();
                return userdocument;
            } else {
                throw new Error("Error")
            }
        }).catch(e => {
            //we want to UI to handle error in EVMs by just opening up the document
            throw new Error("Error")
        });
	},

    createDocument: function(rapidocsid, serviceid){
        let _this = this;
        return UserDocs.remote(
            "createDocumentAjax",
            {
                RAPIDOCSID: rapidocsid,
                SERVICEID: serviceid
            }).then(async function(userdocument) {

                if (userdocument.guid) {
                    _this.parse(userdocument);
                    _this.set(userdocument);

                    return await _this.getEVMs();
                } else {
                    throw new Error("Document not found")
                }
            }).catch(function() {
                //if there's a failure (either from bad json or server failure) handle in UI
                throw new Error("Document not found")
            }
        );
    },
	
	/**
	 * get the evm table for this document
	 */
	getEVMs: function() {
		let _this = this;
        return UserDocs.remote(
			"getDocumentEVMs",
			{
				DOCUMENTID: this.id
			})
        .then(function(data) {
            _this.EVMData = data.EVMS;
            return data.EVMs;
        });
	},
	
	getExternalEVMs: function(documentId) {
        return UserDocs.remote(
			"getDocumentEVMs",
			{
				DOCUMENTID: documentId
			});
	},
	
	getCommonEVMs: function(documentId) {

        return UserDocs.remote(
			"getCommonEVMs",
			{
				DOCUMENTID1: this.id,
				DOCUMENTID2: documentId
			})
        .then(function(data) {
            return data.split(",");
        });
	},

	copyAllEVMs: function(documentId, evmList) {
		let _this = this;
        return UserDocs.remote(
			"copyAllEVMs",
			{
				SOURCEDOCUMENTID: documentId,
				DESTINATIONDOCUMENTID: this.id,
				EVMDEFINITIONS: evmList
			})
            .then(function(data) {
				_this.EVMData = data.EVMS
                return data;
            });
	},
	
	getRegistrationEVMs: function() {
        return UserDocs.remote("getRegistrationEVMs");
	},
	
	copyRegistrationEVMs: function (evmList) {
		let _this = this;
        return UserDocs.remote(
			"copyRegistrationEVMs",
			{
				DOCUMENTID: this.id,
				EVMDEFINITIONS: evmList
			})
        .then(function(data) {
            _this.EVMData = data.EVMS
            return data;
        });
	},
	
	/**
	 * get a list of documents with similar EVM tables
	 */
	getDocumentList: function() {

        return UserDocs.remote(
			"GetCommonEVMDocuments",
			{
				RAPIDOCSID: this.get("RAPIDOCSID")
			})
            .then(function(data) {
                return data;
            });
	},
	/** 
	 * ELE is a little bit inconsistent with returning uppercase or lowercase keys
	 * so force uppercase on all  
 	 * @param {Object} response
	 */
	parse: function(response) {
		$.each(response, function(i, v) {
		    if (i != i.toUpperCase()) {
			    response[i.toUpperCase()] = v;
			    delete response[i];
			}
		});
		return response;
	}
});